import React from 'react';

class CodeFund extends React.Component {
  isLoaded = false;

  constructor(props) {
    super(props);

    const target = 'codefund';

    this.state = {
      target
    };
  }

  componentDidMount() {
    if (!this.isLoaded) {
      this.isLoaded = true;
      const script = this.generateScript();
      document.head.appendChild(script);
      this.codefundRef.outerHTML = script;
    }
  }

  generateScript() {
    const { template, theme } = this.props;
    const { target } = this.state;
    const CODEFUND_LINK = 'https://codefund.io/properties/371/funder.js';

    const script = document.createElement('script');
    script.setAttribute('src', CODEFUND_LINK);
    script.async = 'true';
    script.setAttribute('id', 'external-js');

    return script;
  }

  setRef = (ref) => {
    this.codefundRef = ref;
  }

  render() {
    return (
      <div className='ad-container'>
        <div id={this.state.target} />

        <span style={ { display: 'none' } }>
          <span ref={this.setRef} />
        </span>
      </div>
    );
  }
}

CodeFund.defaultProps = {
  template: 'default',
  theme: 'light'
};

export default CodeFund;